import { ArchiveBoxXMarkIcon } from '@heroicons/react/24/outline';

export const NoData = () => (
  <div className="text-soClean-100 flex flex-col items-center justify-center py-12">
    <span>No Data</span>
    <ArchiveBoxXMarkIcon className="w-20" />
  </div>
);
